module.exports = __webpack_public_path__ + "static/img/2@2x.ccbc5f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/2@2x.png
// module id = wnSb
// module chunks = 1